<template>
  <div>
    <MBanner></MBanner>
    <div class="content-container wrapper">
      <TitleCom
        titleZh="中国汽车流通协会会议"
        titleEn="CHINA AUTOMOBILE DEALERS ASSOCIALION CONFERENCE"
      ></TitleCom>
      <div class="meeting">
        <div
          class="meeting-item"
          v-for="(item, index) in meetingList"
          :key="item.MeetingID"
        >
          <Meeting
            :direction="index % 2 === 1 ? 'right' : 'left'"
            :item="item"
          ></Meeting>
        </div>
      </div>
    </div>
    <div>
      <FlowChart />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeMount } from 'vue'
import MBanner from './banner.vue'
import Meeting from './meeting.vue'
import FlowChart from './flow-chart/index.vue'
import TitleCom from '@/components/TitleCom/index.vue'
import { reqMeetingList } from '@/api/home'

export default defineComponent({
  components: {
    MBanner,
    TitleCom,
    FlowChart,
    Meeting
  },
  setup() {
    const meetingList = ref([])

    onBeforeMount(async () => {
      const temp = await reqMeetingList({ limit: 99999, page: 1 })
      meetingList.value = temp.gridlist
    })
    return {
      meetingList
    }
  }
})
</script>

<style scoped lang="scss">
.content-container {
  margin-top: 40px;
  .meeting {
    margin-top: 37px;
    .meeting-item {
      margin-bottom: 40px;
    }
  }
}
</style>
